import React, { useContext, useState } from 'react';

import { Typography, Tooltip } from '@material-ui/core';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoIcon from '@mui/icons-material/Info';
import propTypes from 'prop-types';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import {
  ClickableContainer,
  Wrapper,
  Spacer,
  UrlContainer,
  TextfieldContainer,
} from './styles';
import { CustomTextField } from '../CustomTextField';
import { ConfirmActionDialog } from '../../../../shared/components/ConfimActionDialog';

export function CopyableUrl({
  url,
  endpoint,
  setEndpoint,
  openTexfield,
  setOpenTexfield,
}) {
  const { setInfoMessage } = useContext(GeneralContext);
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <Wrapper>
        <UrlContainer>
          <ClickableContainer
            onClick={() => {
              navigator.clipboard.writeText(url);
              setInfoMessage('URL copiada com sucesso!');
            }}
          >
            <Typography
              style={{
                fontSize: '13px',
                color: '#616161',
                textDecoration: 'underline',
                paddingRight: '8px',
              }}
            >
              {url}
            </Typography>
            <ContentCopyIcon
              sx={{
                fontSize: '15px',
                color: '#616161',
              }}
            />
          </ClickableContainer>
          {openTexfield ? (
            <Tooltip title="Fechar" placement="left">
              <CancelIcon
                sx={{ cursor: 'pointer' }}
                onClick={() => {
                  setOpenTexfield(false);
                }}
              />
            </Tooltip>
          ) : (
            <Tooltip title="Editar endpoint" placement="left">
              <EditIcon
                sx={{ cursor: 'pointer' }}
                onClick={() => {
                  setOpenDialog(true);
                }}
              />
            </Tooltip>
          )}
        </UrlContainer>
        {openTexfield && (
          <>
            <Spacer />
            <TextfieldContainer>
              <CustomTextField
                value={endpoint}
                setValue={setEndpoint}
                placeholder={url.split('/').pop()}
                disableMargin
              />
              <Tooltip
                title="A entrada será formadada para que não existam espaços em branco nem letras maiúsculas"
                placement="right"
              >
                <InfoIcon style={{ fontSize: 16, marginLeft: '10px' }} />
              </Tooltip>
            </TextfieldContainer>
          </>
        )}
      </Wrapper>
      <ConfirmActionDialog
        open={openDialog}
        confirm={() => {
          setOpenDialog(false);
          setOpenTexfield(true);
        }}
        dismiss={() => setOpenDialog(false)}
        title="Atenção!"
        content="Ao escolher um novo endpoint a URL será alterada, isso pode tornar links previamente criados inváidos. Deseja continuar?"
      />
    </>
  );
}

CopyableUrl.propTypes = {
  url: propTypes.string.isRequired,
};
